import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Icon } from '@chakra-ui/react';
import { FaApplePay } from 'react-icons/fa6';
export const ApplePayButton = (props) => (_jsx(Button, { variant: "outline", onClick: () => props.paymentRequest.show(), ...props, children: _jsx(Icon, { w: 16, h: 16, children: _jsx(FaApplePay, {}) }) }));
